import React from 'react';
import { 
  BackgroundWhiteImg,
  BackgroundBlackImg
} from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { DownloadFile, Margin } from '@helpers';


export const BackgroundColors = ({getFileUrl, t}) => {
    return (
      <PageWrapper darkMode={true}>
        <Container paddingTop='123px' marginLeft='102px' marginRight='52px' paddingBottom='110px'>
          <FlexDiv>
            <Text width='308px' paddingAffterText="40px" paddingBefforeText="45px">
              <h1>{t("Logo background colors")}</h1>
              <p>
                {t("A light radial gradient background is used for the logo inversion, and a dark backdrop is used for the primary logo.")}
              </p>
              <DownloadFile darkMode={true} fileName='background_colors' file={getFileUrl("background_colors")}/>
            </Text>
            <FlexDiv marginTop='22px'>
              <Margin marginLeft='44px'>
                <BackgroundWhiteImg/>
              </Margin>
              <Margin marginLeft='30px'>
                <BackgroundBlackImg/>
              </Margin>
            </FlexDiv>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
